import { Icon } from '@types';

export const Warning = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			width="22"
			height="22"
		>
			<g>
				<circle fill="#ffffff" r="12" id="BG" cy="12" cx="12" />
				<path
					fill="#d72828"
					id="Exclamatory_x5F_Sign"
					d="m10,20l3,0l0,-2l-3,0l0,2zm0,-20l0,16l3,0l0,-14l-3,0z"
				/>
			</g>
		</svg>
	);
};
